import { merge, pick } from 'lodash'
import configuration from "@/store/modules/configuration";
import methods from "@/store/modules/methods";
import products from "@/store/modules/products";
import { handleAxiosException, STATUS_NOT_FOUND } from "@/misc/response";
import { fetchBuild}  from '@/services/api';

export default {
  namespaced: true,
  state: {
    brand: undefined,
    carModel: undefined,
    licensePlate: '',
    color: null,
    color2: null,
    type: null,
    plug: null,
    power: null,
    setting: null,
    method: null,
    system: null,
    socket: 1,
    double: false,
    wishes: '',
  },
  modules: {
    configuration,
    methods,
    products,
  },
  getters: {
    getBrand: (state, getters, rootState, rootGetters) => {
      return rootGetters["brands/mappedById"][state.brand];
    },
    getModel: (state, getters) => {
      return getters.getBrand ? getters.getBrand.car_models.find((model) => model.id === state.carModel) : undefined;
    },
    getWishes: (state) => {
      return state.wishes;
    },
    getConfiguration(state) {
      return state;
    },
    getConfigurationSummary(state, getters, globalState, globalGetters) {
      let methods = globalGetters['methods/all'];
      let type = globalGetters['types/current'];
      let plugs = globalGetters['methods/plugs'];
      let power = globalGetters['types/chosenProperty']('powers', state.power);

      let result = {
        'Vermogen': globalGetters['types/chosenProperty']('powers', state.power, 'name'),
        'Start/stop': globalGetters['types/chosenProperty']('systems', state.system, 'name'),
      };


      if (type.type === 'laadpaal') {
        let method;
        if (methods && state.method) {
          method = methods.find((p) => {
            return p.id === state.method;
          });
          if (method) result['Laadmethode'] = method.name;
        }
        if (method && method.with_plugs) {
          let plug;
          plug = plugs.find((p) => {
            return p.id === state.plug;
          });
          if (plug) result['Stekker'] = plug.name;
        }
      }

      if (type.type === 'laadpaal' && state.socket) {
        result = {
          ...result,
          'Stopcontact': globalGetters['types/chosenProperty']('sockets', state.socket, 'name'),
        };
      } else if (type.type === 'laadzuil') {
        result = {
          ...result,
          'Aantal aansluitingen': state.double ? '2 aansluitingen' : '1 aansluiting',
        };
      }

      if (type.type === 'laadpaal') {
        result = {
          ...result,
          'Kleur': globalGetters['types/chosenProperty']('colors', state.color, 'name'),
        }
      } else if(type.type === 'laadzuil') {
        result = {
          ...result,
          'Kleur': globalGetters['types/chosenProperty']('colors', state.color2, 'name'),
        }
      }

      let ampere;
      if (power && state.setting) {
        ampere = power.settings.find((p) => {
          return p.id === state.setting;
        });
        if (ampere) result['Ampere'] = ampere.name;
      }

      return result;
    },
    getConfigurationPrices(state, getters, globalState, globalGetters) {
      let type = globalGetters['types/current'];
      let methods = globalGetters['methods/all'];
      let plugs = globalGetters['methods/plugs'];
      let power = globalGetters['types/chosenProperty']('powers', state.power);

      let prices = {
        'Vermogen': globalGetters['types/chosenProperty']('powers', state.power, 'price'),
        'Start/stop': globalGetters['types/chosenProperty']('systems', state.system, 'price'),
      };

      if (!type) return 0;

      //type Laadpaal
      if (type.type === 'laadpaal') {
        let method;
        if (methods && state.method) {
          method = methods.find((p) => {
            return p.id === state.method;
          });
          if (method) prices['Laadmethode'] = method.price;
        }
        if (method && method.with_plugs) {
          let plug;
          plug = plugs.find((p) => {
            return p.id === state.plug;
          });
          if (plug) prices['Stekker'] = plug.price;
        }
        prices = {
          ...prices,
          'Kleur': globalGetters['types/chosenProperty']('colors', state.color, 'price'),
        };
      }

      //type Laadzuil
      if (type.type === 'laadzuil') {
        let doublePrice = state.double ? globalGetters['settings/priceDoublePillar'] : 0;

        prices = {
          ...prices,
          'Kleur': globalGetters['types/chosenProperty']('colors', state.color2, 'price'),
          'Double': doublePrice
        };
      }

      if (state.socket && type.type === 'laadpaal') {
        prices = {
          ...prices,
          'Stopcontact': globalGetters['types/chosenProperty']('sockets', state.socket, 'price'),
        }
      }

      let ampere;
      if (power && state.setting) {
        ampere = power.settings.find((p) => {
          return p.id === state.setting;
        });
        if (ampere) prices['Ampere'] = ampere.price;
      }

      if (type && state.type) prices['Type'] = type.price;

      return prices;
    },

    getBuild(state, getters, rootState, rootGetters) {
      const type = rootGetters['types/current'];

      // keys to retrieve from the build
      let properties = ['type', 'power', 'system', 'setting'];
      let extendProperties = [];
      let build = {
        amount: rootGetters['order/getOrderAmount']
      };

      if (type.type === 'laadpaal') {
        build.color = state.color;

        extendProperties = ['method', 'plug', 'socket'];
      } else if (type.type === 'laadzuil') {
        build.color = state.color2;

        extendProperties = ['double'];
      }

      // Merge extend with properties
      properties = properties.concat(extendProperties);

      // Pick the properties form the build which are needed
      // Then merge them with the original object (includes color, ral for example)
      return merge(build, pick(state, properties));
    },

    getProductsAndWishes(state, getters, rootState, rootGetters) {
      let properties = ['products', 'wishes'];
      let build = {
        amount: rootGetters['order/getOrderAmount']
      };

      build.wishes = state.wishes;

      return merge(build, pick(state, properties));
    },

    selectedColorId(state, getters, rootState, rootGetters) {
      const type = rootGetters['types/current'];

      if (type) {
        return type.type === 'laadpaal' ? state.color : state.color2;
      }
    },

    selectedColor(state, getters, rootState, rootGetters) {
      const type = rootGetters['types/current'];
      const colorId = getters['selectedColorId'];

      if (type && type.colors) {
        return type.colors.filter(({id}) => {
          return id === colorId;
        });
      }
    },

    deliveryDays(state, getters) {
      if (getters['selectedColor']) {
        return getters['selectedColor'][0].delivery_days;
      }
    },
    getLicensePlate(state) {
      return state.licensePlate;
    },
  },
  actions: {
    reset({state, commit}) {
      let {plug, power} = state.configuration;
      commit('RESET', state.configuration)
    },
    initialize({commit, state, rootState}) {
      const {types, methods} = rootState;
      const firstType = types['all'][0];

      commit('SET_TYPE', firstType.id);
      commit('SET_POWER', firstType['powers'][0].id);
      commit('SET_PLUG', methods['plugs'][1].id);
      commit('SET_METHOD', methods['all'][0].id);

      let system = firstType.systems.find((system) => {
        return system.default;
      });
      if (system) commit('SET_SYSTEM', system.id);

      commit('SET_COLOR', firstType.colors[0].id);
      commit('SET_COLOR2', types['all'][1].colors[0].id);
      commit('SET_SETTING', firstType.powers[0].settings[0].id);
    },
    changeType({commit, rootGetters, state}, payload) {
      let oldSystem = rootGetters['types/chosenProperty']('systems', state.system);

      commit('SET_TYPE', payload.value)

      // check if type has system, if not pick simular named option else default
      let newType = rootGetters['types/current'];
      if (!newType.systems.find(system => oldSystem.id === system.id)) {
        let newSystem = newType.systems.find(system => oldSystem.name === system.name);
        if (newSystem) {
          commit('SET_SYSTEM', newSystem.id);
        } else {
          newSystem = newType.systems.find(system => system.default);

          if (newSystem) {
            commit('SET_SYSTEM', newSystem.id);
          }
        }
      }
    },
    changePlug({commit}, payload) {
      commit('SET_PLUG', payload.value)
    },
    changeSystem({commit, rootGetters}, {value}) {
      const system = rootGetters['types/current']
        .systems
        .find(system => system.id === value);

      if (system && system.disable_socket === 1) {
        commit('SET_SOCKET', false);
      } else {
        commit('SET_SOCKET', 1);
      }

      commit('SET_SYSTEM', value);
    },
    changeColor({commit}, payload) {
      commit('SET_COLOR', payload.value)
    },
    changeColor2({commit}, payload) {
      commit('SET_COLOR2', payload.value)
    },
    changePower({commit}, payload) {
      commit('SET_POWER', payload.value)
    },
    changeMethod({commit}, payload) {
      commit('SET_METHOD', payload.value)
    },
    setMethodByName({rootGetters, commit}, name) {
      let methods = rootGetters['methods/all'];
      let method = methods.find((method) => {
        return method.name === name;
      });
      commit('SET_METHOD', method.id)
    },
    changeSetting({commit}, payload) {
      commit('SET_SETTING', payload.value)
    },
    changeDouble({commit}, payload) {
      commit('SET_DOUBLE', payload.value)
    },
    changeBrand({commit}, payload) {
      commit('SET_BRAND', payload)
    },
    changeCarModel({commit}, payload) {
      commit('SET_CAR_MODEL', payload)
    },
    changeWishes({commit}, payload) {
      commit('SET_WISHES', payload)
    },
    changeConfiguration({dispatch, commit}, payload) {
      commit('configuration/SET', payload);
      dispatch('reset');
    },
    async fetchBuild({ rootState, dispatch }, buildNr) {
      try {
        const { data } = await fetchBuild(rootState.environmentId, buildNr);

        await dispatch('loadBuild', data);
      } catch (exception) {
        const status = handleAxiosException(exception);

        if (status === STATUS_NOT_FOUND) {
          console.warn(`build with number ${buildNr} not found, basic settings are used`)
        }
      }
    },
    async loadBuild({ dispatch, rootState, getters, commit }, build) {
      const buildObject = build.build;

      if (buildObject === undefined) {
        throw new Error('Build has no build object');
      }

      commit('SET_TYPE', buildObject.type);

      if (buildObject.type === 1) { // Laadpaal
        commit('SET_METHOD', buildObject.method);
        commit('SET_PLUG', buildObject.plug);
        commit('SET_COLOR', buildObject.color);
      } else if (buildObject.type === 2) { // Laadzuil
        commit('SET_DOUBLE', buildObject.double);
      }

      await dispatch('changeSystem', { value: buildObject.system });
      commit('SET_POWER', buildObject.power);
      commit('SET_SETTING', buildObject.setting);
      commit('SET_WISHES', buildObject.wishes);
      commit('SET_CAR_MODEL', undefined);
      commit('SET_BRAND', undefined);
    },
  },
  mutations: {
    SET_TYPE(state, value) {
      state.type = value;
    },
    SET_PLUG(state, value) {
      state.plug = value;
    },
    SET_SYSTEM(state, value) {
      state.system = value;
    },
    SET_POWER(state, value) {
      state.power = value;
    },
    SET_METHOD(state, value) {
      state.method = value;
    },
    SET_SETTING(state, value) {
      state.setting = value;
    },
    SET_SOCKET(state, value) {
      state.socket = value;
    },
    SET_DOUBLE(state, value) {
      state.double = value;
    },
    SET_BRAND(state, value) {
      state.brand = value;
    },
    SET_CAR_MODEL(state, value) {
      state.carModel = value;
    },
    SET_COLOR(state, value) {
      state.color = value;
    },
    SET_COLOR2(state, value) {
      state.color2 = value;
    },
    SET_WISHES(state, value) {
      state.wishes = value;
    },
    setLicensePlate(state, value) {
      state.licensePlate = value;
    },
    RESET(state, value) {
      Object.keys(value).forEach((key, index) => {
        state[key] = value[key]
      })
    },
  },
};
